import React, { useEffect, useState, useRef } from 'react';
import connect from '../../stores/parent-dashboard';
import {UnlinkChildApi} from '../../../js/services/parent-api'
import {LocalStorageMap} from './../../../js/components/common/local-storage-utils'

/**
 * This component renders the delete consent popup on clicking delete icon on edit child details page
 * @property {function} setShowDeleteConsentPopup To show or hide this component
 * @property {function} setModifiedStudents Removes deleted student and sets remaining students
 * @property {function} setActiveStudent sets first student in array as active student
 */

function DeleteConsentPopup ({setShowDeleteConsentPopup, childName, student, students, setModifedStudents, setActiveStudent}) {

	const removeChild = async() =>{
		try {
			await UnlinkChildApi({student_id:student.id})
			var modifiedStudents =  students.filter(ele => ele.id !== student.id)
			localStorage.setItem(LocalStorageMap['hasDelinkedChild'], 'true');
			localStorage.setItem(LocalStorageMap['studentName'], childName);
			setModifedStudents(modifiedStudents)
			if(modifiedStudents.length == 0){
				location.reload()
			}
			else{
				setActiveStudent({student: modifiedStudents[0], grade: modifiedStudents[0].grade_code});
			  location.hash = '/settings'
			}
		 }
		 catch(error) {
			 console.error(error)       
		 }
	}

  return (
    <div className="delete-consent-popup-overlay">
			<div className="delete-consent-popup">
				<p className="header">Remove {childName}’s profile </p>
        <p className="delete-consent-popup-body">{childName} will not have access to SplashLearn after school hours and you will no longer be able to view their progress.</p>
				<a onClick = {removeChild} className="button">Yes, Remove</a>
				<div className="cross-icon" onClick={()=>{setShowDeleteConsentPopup(false)}}>
					<i class="iconcust-iconCrossBtn"/>
				</div>
			</div>
		</div>
	)
}

function mapDispatchToProps(dispatch){
  return{
    setModifedStudents: (data) => dispatch({type: 'SET_MODIFIED_STUDENTS', payload: data}),
		setActiveStudent: (data) => dispatch({type: 'SET_ACTIVE_STUDENT', payload: data}),
  }
}

export default connect(null, mapDispatchToProps, DeleteConsentPopup)